// extracted by mini-css-extract-plugin
export default {"container":"CartItem_container__ZA2G3","cartImg":"CartItem_cartImg__fdWtT"};